<template>
  <div class="main-page">
    <Header></Header>
    <Banner></Banner>
    <div class="m-pc-page page-bottom">
      <Column></Column>
      <List></List>
    </div>
  </div>
</template>
<script>
//import Vue from "vue";
import Header from "../components/Header";
import Column from "../components/Column.vue";
import Banner from "../components/Banner.vue";
import List from "../components/List.vue";
import { $subscriber } from "fire-wind-water";

import { articleCategoryId } from "../common/sbase";
//  import $ from "jquery";

export default {
  name: "Article",
  data() {
    return {};
  },
  methods: {
    getCategory() {
      articleCategoryId;
    }
  },
  created() {
    $subscriber.subscribe("config-loaded", res => {
      res;
      //      this.page = res.page;
      // $('body').css('background-color',this.page.backgroundColor.value)
      //      window.$sk.loading.hide();
    });
  },
  components: {
    Header,
    Column,
    Banner,
    List
  }
};
</script>
